module.exports = __webpack_public_path__ + "static/img/VDappScenarios1-1.7dca3f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDappScenarios1-1.png
// module id = o5h9
// module chunks = 0